// src/actions/languageActions.js
import api from '../api/axios';
import {
  FETCH_LANGUAGE_REQUEST,
  FETCH_LANGUAGE_SUCCESS,
  FETCH_LANGUAGE_FAILURE,

  CREATE_LANGUAGE_REQUEST,
  CREATE_LANGUAGE_SUCCESS,
  CREATE_LANGUAGE_FAIL,

  DELETE_LANGUAGE_REQUEST,
  DELETE_LANGUAGE_SUCCESS,
  DELETE_LANGUAGE_FAIL,

  UPDATE_LANGUAGE_REQUEST,
  UPDATE_LANGUAGE_SUCCESS,
  UPDATE_LANGUAGE_FAIL

} from '../constants/languageConstants';

export const fetchLanguage = () => async (dispatch) => {
  dispatch({ type: FETCH_LANGUAGE_REQUEST });

  try {
    const { data } = await api.get('/language/my-languages/');

    dispatch({
      type: FETCH_LANGUAGE_SUCCESS,
      payload: data.results || data || []
    });

  } catch (error) {
    dispatch({
      type: FETCH_LANGUAGE_FAILURE,
      payload: error.response && error.response.data.detail
        ? error.response.data.detail
        : error.message,
    });
  }
};

export const createLanguage = (name, level, type) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_LANGUAGE_REQUEST });

    await api.post('/language/my-languages/create/', {
      name: name,
      level: level,
      type: type
    });

    dispatch({ type: CREATE_LANGUAGE_SUCCESS });
    dispatch(fetchLanguage());
  } catch (error) {
    dispatch({
      type: CREATE_LANGUAGE_FAIL,
      payload: error.response?.data?.non_field_errors?.[0] || error.message
    });
  }
};

export const deleteLanguage = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_LANGUAGE_REQUEST });

    await api.delete(`/language/my-languages/delete/${id}/`);

    dispatch({ type: DELETE_LANGUAGE_SUCCESS });
    dispatch(fetchLanguage());
  } catch (error) {
    dispatch({
      type: DELETE_LANGUAGE_FAIL,
      payload: error.response?.data?.detail || error.message
    });
  }
};

export const updateLanguage = (id, name, level, type) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_LANGUAGE_REQUEST });

    const { data } = await api.put(
      `/language/my-languages/update/${id}/`,
      { name, level, type }
    );

    dispatch({
      type: UPDATE_LANGUAGE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_LANGUAGE_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};